import React from 'react'
import {Actions} from 'jumpstate'
import {Form} from 'react-form'
import validateContact from '../../../utils/validateContact'
import ContactForm from './ContactForm.js'
import showToastr from '../../../utils/showToastr'
import ErrorHandler from '../../../utils/ErrorHandler'

class ContactBox extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {status: '', context: ''},
      show: true,
      isLoading: false
    }
  }
  render () {
    const {message, show, isLoading} = this.state
    return (
      <div id="contact-us">
        {show && <Form
          ref="form"
          validate={validateContact}
          message={message}
          isLoading={isLoading}
          disable={isLoading}
          onSubmit={(values) => {
            if (isLoading) return false
            this.setState({isLoading: true})
            Actions.contact(values).then((res) => {
              this.setState({
                isLoading: false,
                show: false
              }, () => this.setState({show: true}))
              showToastr('success', 'تماس با ما', res.data.messages[0])
            }).catch((err) => {
              let eh = new ErrorHandler(err)
              this.setState({message: eh.message, isLoading: false})
              eh.setFormErrors(this.refs.form)
              eh.showToastrIn('تماس با ما')
            })
          }}>
          {ContactForm}
        </Form>}
      </div>
    )
  }
}

export default ContactBox



// WEBPACK FOOTER //
// ./src/components/Common/ContactBox/ContactBox.js